import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from '@nibfe/mkt-env-api';
import Navigate from '@nibfe/mkt-navigate-api';
import { DETAIL_PAGE_ANCHOR } from '../types';
import { convertTimestampToDate } from './common';
const { invokeJump } = Navigate;
const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
const getMaxPoiDetailSwitch = () => {
    const search = location.search.slice(1);
    const params = new URLSearchParams(search);
    const maxPoiDetailSwitch = params.get('maxPoiDetailSwitch');
    console.log('maxPoiDetailSwitch', maxPoiDetailSwitch);
    return maxPoiDetailSwitch === 'true';
};
export const navigateToDetailPage = (detail, monitorNavigateTo, extra) => {
    const { poiId, shopuuid, hotelchannel, shopIdStr } = detail;
    const { isNeedAdd, extraParamsString, anchor, externalParams } = extra || {};
    /**
     * @see https://km.sankuai.com/collabpage/316184155
     * 为什么使用MRN链接?
     * - 因为 ignoreDateUpdate 参数仅在MRN链接时生效
     */
    let mrnUrl = `imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&id=${poiId}&hotelchannel=${hotelchannel ?? '-999'}&ignoreDateUpdate=true&newPageSource=promotionPage`;
    if (anchor && anchor !== DETAIL_PAGE_ANCHOR.NONE) {
        mrnUrl = `${mrnUrl}&anchor=${anchor.toLowerCase()}`;
    }
    if (externalParams && externalParams.checkInTimestamp && externalParams.checkOutTimestamp) {
        mrnUrl = `${mrnUrl}&checkindate=${convertTimestampToDate(externalParams.checkInTimestamp)}&checkoutdate=${convertTimestampToDate(externalParams.checkOutTimestamp)}`;
    }
    if (isNeedAdd && extraParamsString) {
        mrnUrl = `${mrnUrl}&${extraParamsString}`;
    }
    const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(mrnUrl);
    if (isMeituanAppOrWebview()) {
        invokeJump(mrnUrl);
    }
    else if (isDianpingAppOrWebview()) {
        // 点评app
        invokeJump(`dianping://shopinfo?shopuuid=${shopuuid}&id=${shopIdStr}&=&hotelchannel=${hotelchannel ?? '-999'}`);
    }
    else if (isWeixinMiniProgramOrWeixinWebview()) {
        const platformType = getPlatformType();
        switch (platformType) {
            case PlatformType.mtMinaWebview:
                // 美团小程序
                monitorNavigateTo({
                    url: `${getMaxPoiDetailSwitch() ? '/max-poi-detail/pages/poidetail/index' : '/hotel/pages/poi/pages/index/index'}?poiId=${poiId}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.mtHotelMinaWebview:
                // 美团酒店小程序
                monitorNavigateTo({
                    url: `${getMaxPoiDetailSwitch() ? '/max-poi-detail/pages/poidetail/index' : '/pages/poi/pages/index/index'}?poiId=${poiId}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.dpMinaWebview:
                // 点评小程序
                monitorNavigateTo({
                    url: `/packages/hotel/pages/poi/pages/index/index?shopId=${poiId}&shopUuid=${shopuuid}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            default:
                monitorNavigateTo({
                    url: envokePoiDetailLink
                });
                break;
        }
    }
    else {
        monitorNavigateTo({
            url: envokePoiDetailLink
        });
    }
};
